import React from 'react';

const HelpModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-2xl font-bold text-gray-800">Welcome to PaddleMatch!</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                        >
                            &times;
                        </button>
                    </div>

                    <div className="space-y-6 text-gray-600">
                        <p>
                            The goal is to cut down on group texts and help you meet suitable players.
                            Find a game or "Light a Fire" to start one!
                        </p>

                        <div>
                            <h3 className="text-lg font-semibold text-sky-700 mb-2">1. Set Up Your Profile</h3>
                            <p>Make sure your profile is complete so others know your skill level (PTI) and where you like to play.</p>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-sky-700 mb-2">2. Find or Create a Hut</h3>
                            <ul className="list-disc pl-5 space-y-1">
                                <li><strong>Join a Hut:</strong> Browse the "Huts" list to find a game that fits your schedule and skill level.</li>
                                <li><strong>Light a Fire:</strong> Can't find a game? Create a new "Hut" (game instance) and wait for others to join.</li>
                            </ul>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-sky-700 mb-2">3. Play!</h3>
                            <p>Once a Hut is full (4 players), the status becomes "Confirmed". It's up to the group to coordinate court reservations.</p>
                        </div>
                    </div>

                    <div className="mt-8 text-center">
                        <button
                            onClick={onClose}
                            className="px-6 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors"
                        >
                            Got it, let's play!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpModal;
